import { IForgotPasswordVariables, ILoginVariables, INewPasswordVariables, IVerifyAccount } from '@/domain/auth/entities';
import { EMAIL_PATTERN } from '@/utils/validate/email';
import { JSONSchemaType } from 'ajv';

export const schemaLogin: JSONSchemaType<ILoginVariables> = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Email is required' },
    },
    password: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Password is required' },
    },
  },
  required: ['email'],
  additionalProperties: false,
};

export const schemaForgotPassword: JSONSchemaType<IForgotPasswordVariables> = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: EMAIL_PATTERN,
      minLength: 1,
      maxLength: 254,
      errorMessage: { minLength: 'Email is required', pattern: 'Email is invalid' },
    },
  },
  required: ['email'],
  additionalProperties: false,
};

export const schemaNewPassword: any = {
  type: 'object',
  properties: {
    newPassword: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'New password is required' },
    },
    confirmNewPassword: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Confirm password is required' },
    },
  },
  required: ['newPassword', 'confirmNewPassword'],
  additionalProperties: false,
};

export const schemaSignup: any = {
  type: 'object',
  properties: {
    firstName: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'First name is required' },
    },
    lastName: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Last name is required' },
    },
    email: {
      type: 'string',
      pattern: EMAIL_PATTERN,
      minLength: 1,
      maxLength: 254,
      errorMessage: { minLength: 'Email is required', pattern: 'Email is invalid' },
    },
    password: {
      type: 'string',
      minLength: 1,
      pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})',
      errorMessage: {
        minLength: 'Password is required',
        pattern:
          'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)',
      },
    },
    confirmPassword: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Confirm password is required',
      },
    },
    // isAgree: {
    //   type: 'boolean',
    //   // minLength: 1,
    //   "nullable": true
    //   // errorMessage: { minLength: 'A is required' },
    // }
  },
  required: ['firstName', 'lastName', 'email', 'password', 'confirmPassword'],
  additionalProperties: true,
};

export const schemaVerifyAccount: any = {
  type: 'object',
  properties: {
    activeKey: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Code is required' },
    },
  },
  required: ['activeKey'],
  additionalProperties: false,
};

export const schemaBusinessInformation: any = {
  type: 'object',
  properties: {
    businessNumber: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Business number is required' },
    },
    businessName: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Business name is required' },
    },
    businessAddress: {
      type: 'string',
      nullable: true,
    },
    entityType: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Business type is required' },
    },
    entityTypeLabel: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Business type is required' },
    },
    fnYear: {
      type: ['string', 'number'],
      minLength: 1,
      errorMessage: { minLength: 'Year is required' },
    },
    businessIndustryId: {
      type: 'string',
      minLength: 1,
      errorMessage: { minLength: 'Business industry is required' },
    },
  },
  required: ['businessNumber', 'fnYear', 'businessIndustryId'],
  additionalProperties: true,
};
